import { useDocumentsRepository } from '@Hooks/useRepository';
import { PrintOptionsRepository } from '@Repositories/Documents';
import type { ListRequestWithIds } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';

/**
 * What the ZIP archive of `selection` would contain. Asks nothing while `selection` is undefined, and keeps the
 * figures it already has for a selection while it asks again.
 */
// @ai-generated 2026-10-01T03:51:25+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function useArchivePreview(printOptionId: string, selection: ListRequestWithIds | undefined) {
    const printOptions = useDocumentsRepository(PrintOptionsRepository);

    const { data: result, isFetching } = useQuery({
        queryKey: ['documents', 'print_options', printOptionId, 'archive_preview', selection],
        queryFn: () => printOptions.getArchivePreview(printOptionId, selection!),
        enabled: selection !== undefined,
    });

    return {
        preview: result?.data ?? undefined,
        messages: result?.messages ?? [],
        isLoading: isFetching && result === undefined,
    };
}
